// src/components/Project.jsx
import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import { Link } from 'react-router-dom';

const Project = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchProjects = async () => {
    try {
      const snapshot = await getDocs(collection(db, 'projects'));
      const list = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));
      setProjects(list);
    } catch (err) {
      console.error('Error fetching projects', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProjects();
  }, []);

  if (loading) return <div>Loading projects...</div>;

  return (
    <div style={{ padding: '40px', textAlign: 'center' }}>
      <h2>Projects</h2>

      <Link to="/projects/new">
        <button style={{ marginBottom: '30px' }}>
          Add New Project
        </button>
      </Link>

      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '20px',
          justifyContent: 'center',
        }}
      >
        {projects.map(project => (
          <Link
            key={project.id}
            to={`/project/${project.id}`}
            style={{
              width: '250px',
              padding: '20px',
              borderRadius: '10px',
              background: '#f5f5f5',
              textDecoration: 'none',
              color: '#000',
              boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
            }}
          >
            <h3>{project.title}</h3>
            <p>{project.caption}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Project;
